import { useWindowOpen } from '@repo/platform';
import { useUserEventLogger } from '@repo/tracking-service';
import { List, SubTitle, Svg } from '@repo/ui';

import s from './menu.module.scss';

export const HelpSection = () => {
  const { sendClickEvent } = useUserEventLogger();
  const { openWindow } = useWindowOpen();

  const guideOpenNewTab = (link: string, clickEvent: string) => {
    sendClickEvent(clickEvent);

    openWindow(link);
  };

  return (
    <li>
      <SubTitle title={'도움말'} size={'medium'} className={s.menu_list_padding} />

      <ul>
        <li className={s.menu_list_padding}>
          <List
            title={'이용 가이드'}
            leadingElement={<img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/icons/fill-idea-rg.svg`} alt="전구" width={32} height={32} />}
            supportingElement={<Svg src={'ic_chevron-right.svg'} width={20} height={20} color={'#8A96A3'} />}
            primaryAction={true}
            onClick={() => guideOpenNewTab('https://help.bznav.com/hc/ko/sections/31995877295385', 'more_body_user-guide')}
          />
        </li>
        <li className={s.menu_list_padding}>
          <List
            title={'자주 묻는 질문'}
            leadingElement={<img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/icons/fill-c-question-bl-rg.svg`} alt="물음표" width={32} height={32} />}
            supportingElement={<Svg src={'ic_chevron-right.svg'} width={20} height={20} color={'#8A96A3'} />}
            primaryAction={true}
            onClick={() => guideOpenNewTab('https://help.bznav.com/hc/ko/sections/31995733718297', 'more_body_faq')}
          />
        </li>
      </ul>
    </li>
  );
};
